class Dropdown {
    constructor(options) {
        const _ = this;

        _._option = $.extend({
                $node: null,
                prefix: 'ui-dropdown',
                selectedClass: 'is-selected',
                selectCallback: null
            },
            options
        );

        _._$node = _._option.$node;

        _._$title = _._$node.find(`.${_._option.prefix}-title`);
        _._$list = _._$node.find(`.${_._option.prefix}-list`);
        _._$select = _._$node.find(`.${_._option.prefix}-select`);

        _._isInitialized = false;
    }

    init() {
        const _ = this;

        if (_._isInitialized)
            throw new Error('Dropdown is already initialized.');

        _._setEvent();

        _._isInitialized = true;

        return _;
    }

    _setEvent() {
        const _ = this;

        _._$title.on('click', evt => _._clickTitle(evt));

        _._$list.on('click', 'button', evt => _._clickListItem(evt));

        $(document).on('click', evt => _._clickDocument(evt));
    }

    _clickTitle(evt) {
        const _ = this;

        _._$list.is(':visible') ? _._showList(false) : _._showList(true);
    }

    _clickListItem(evt) {
        const _ = this;

        const $btn = $(evt.currentTarget),
            $listItems = _._$list.find('li'),
            $selectedListItem = $btn.closest('li'),
            index = $listItems.index($selectedListItem);

        _.setValueByIndex(index);

        _._showList(false);

        if (_._option.selectCallback)
            _._option.selectCallback.call(null, {
                value: $btn.text(),
                item: $selectedListItem.get(0),
                index: index
            });
    }

    _clickDocument(evt) {
        const _ = this;

        if (_._$node.has(evt.target).length <= 0) {
            if (_._$list.is(':visible')) _._showList(false);
        }
    }

    _setTitle(str) {
        this._$title.text(str);
    }

    _showList(flag) {
        flag === true ? this._$list.show() : this._$list.hide();
    }

    getActivatedOptionValue() {
        const _ = this;

        let value = null;

        const optionBtn = _._$select.find(':selected');
        if (optionBtn.length) value = optionBtn.attr('value');

        return value;
    }

    setValueByIndex(index) {
        const _ = this;

        const $listItems = _._$list.find('li'),
            $btn = $('button', $listItems.eq(index));

        // activate list item
        $listItems.removeClass(_._option.selectedClass);
        $listItems.eq(index).addClass(_._option.selectedClass);

        // activate select option
        const $selectOptions = _._$select.find('option');
        $selectOptions.attr('selected', false);
        $selectOptions.eq(index).attr('selected', true);

        _._setTitle($btn.text());
    }
}

export default Dropdown;